import { useLocation } from 'react-router';
import { CART_PARAM, TOKEN_PARAM } from '../multiuser';

export const useCheckMultiuserLink = () => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const tokenFromInvite = searchParams.get(TOKEN_PARAM);
  const cartIdFromInvite = searchParams.get(CART_PARAM);

  const isMultiuserLink = tokenFromInvite && cartIdFromInvite;

  return {
    isMultiuserLink,
    tokenFromInvite,
    cartIdFromInvite,
  };
};
